import Seo from './components/seo.js';

class enhancedSeo {
  /**
     * @function clickStoreDetails - Get store detail when click to details button
     * @param {Object} marker - store object information
     * @param {Array} elements - array with all necessary elements
     */
  clickStoreDetails(marker, elements) {
    if (this.checkIfArray(elements, 2)) {
      const $isStoreLocatorList = $(elements[0]);
      if ($isStoreLocatorList.length) {
        $isStoreLocatorList.on('click', elements[1], (e) => {
          dataLayer.push({
            event: 'asyncAction',
            gaHitType: 'event',
            event_category: 'store_locator',
            event_action: 'dettaglio_store',
            event_label: marker.store.name + ', ' + marker.store.address1
          });
        });
      }
    }
  }

  /**
     * @function selectedStoreDetail - Get selected store for seo
     * @param {Object} marker - store object information
     */
  selectedStoreDetail(marker) {
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      event_category: 'store_locator',
      event_action: 'select_store',
      event_label: marker.store.name + ', ' + marker.store.address1
    });
  }

  /**
     * @function clickCreateAccountHeaderPopup - Get store detail when click on create account button header
     * @param {Array} elements - array with all necessary elements
     */
  clickCreateAccountHeaderPopup(elements) {
    if (this.checkIfArray(elements, 2)) {
      const $isPopupFooterHeader = $(elements[0]);
      if ($isPopupFooterHeader.length) {
        $isPopupFooterHeader.on('click', elements[1], (e) => {
          dataLayer.push({
            event: 'asyncAction',
            gaHitType: 'event',
            event_category: 'my_account',
            event_action: 'crea_il_mio_account',
            event_label: ''
          });
        });
      }
    }
  }

  /**
     * @function clickMobileFooterMenu - Get seo when click on mobile footer menu
     * @param {Array} elements - array with all necessary elements
     */
  clickMobileFooterMenu(elements) {
    if (this.checkIfArray(elements, 3)) {
      const isMobileMenu = $(elements[0]);
      if (isMobileMenu.length) {
        $(isMobileMenu).on('click', elements[1], (e) => {
          const iconName = $(e.currentTarget).attr(elements[2]);
          if (iconName) {
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'funzionalita_cross',
              event_action: 'menu',
              event_label: iconName
            });
          }
        });
      }
    }
  }

  /**
     * @function clickOnCookieBanner - Get seo click on cookie banner
     * @param {Array} elements - array with all necessary elements
     */
  clickOnCookieBanner(elements) {
    if (this.checkIfArray(elements, 3)) {
      const isCookieAlert = $(elements[0]);
      if (isCookieAlert.length) {
        const elementList = [elements[1], elements[2]];
        elementList.forEach((elem) => {
          isCookieAlert.on('click', elem, (e) => {
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'funzionalita_cross',
              event_action: 'cookie_bar',
              event_label: 'accettazione_cookie_policy'
            });
          });
        });
      }
    }
  }

  loginLogoutEvent(eventType, loyaltyLevel){
      dataLayer.push({
        event: "account_login",
        login_method: "email",
        timestamp: new Date().toISOString(),
        membership_type: loyaltyLevel,
        event_action: eventType
      });
  }

  /**
     * @function clickOnSearch - Get seo click on search
     * @param {Array} elements - array with all necessary elements
     */
  clickOnSearch(elements) {
    if (this.checkIfArray(elements, 4)) {
      const isSearch = $(elements[0]);
      if (isSearch.length) {
        let classObj = {};
        classObj[elements[1]] = 'chiudi';
        classObj[elements[2]] = 'scoprili_tutti';
        classObj[elements[3]] = 'esplora';

        Object.keys(classObj).forEach((element) => {
          isSearch.on('click', element, (e) => {
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'funzionalita_cross',
              event_action: 'ricerca',
              event_label: classObj[element]
            });
          });
        });
      }
    }
  }

  /**
     * @function clickChat - Get seo event when click on chat button
     * @param {Array} elements - array with all necessary elements
     */
  clickChat(elements) {
    if (this.checkIfArray(elements, 1)) {
      const isChat = $(elements[0]);
      if (isChat.length) {
        isChat.on('click', (e) => {
          dataLayer.push({
            event: 'asyncAction',
            gaHitType: 'event',
            event_category: 'funzionalita_cross',
            event_action: 'chat'
          });
        });
      }
    }
  }

  /**
     * @function noSizeClick - Get seo event when no size product was clicked
     * @param pid - product id
     * @param {Array} elements - array with all necessary elements
     */
  noSizeClick(pid, elements) {
    if (this.checkIfArray(elements, 2)) {
      let colorName = $(elements[0]).data(elements[1]);
      if (pid && colorName) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'pdp',
          event_action: 'aggiungi_alla_shopping_bag',
          event_label: pid + '|' + colorName
        });
      }
    }
  }

  /**
     * @function noSizeWishlistClick - Get seo event when no size product was clicked
     * @param pid - product id
     * @param {Array} elements - array with all necessary elements
     */
  noSizeWishlistClick(pid, elements) {
    if (this.checkIfArray(elements, 2)) {
      let colorName = $(elements[0]).data(elements[1]);
      if (pid && colorName) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'pdp',
          event_action: 'add_to_wishlist',
          event_label: pid + '|' + colorName
        });
      }
    }
  }

  /**
     * @function clickAccordion - Get seo event when click accordion PDP
     * @param {Array} elements - array with all necessary elements
     */
  clickAccordion(elements) {
    if (this.checkIfArray(elements, 2)) {
      $(document).on('click', elements[0], (event) => {
        const $self = $(event.currentTarget);
        var accordionText = $self.text().trim();
        var accordionExpanded = $self.attr(elements[1]);

        if (accordionExpanded == 'true') {
          accordionExpanded = 'chiudi';
        } else {
          accordionExpanded = 'apri';
        }
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'pdp',
          event_action: 'contenuti',
          event_label: accordionText + '|' + accordionExpanded
        });
      });
    }
  }

  /**
     * @function breadcrumbsClick - Get seo event when click on breadcrumbs
     * @param {Array} elements - array with all necessary elements
     */
  breadcrumbsClick(elements) {
    if (this.checkIfArray(elements, 2)) {
      $(document).on('click', elements[0], (e) => {
        if (window.device.type === 'mobile') {
          let categoryID = $(e.currentTarget).attr(elements[1]);
          if (categoryID) {
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'pdp',
              event_action: 'breadcrumb',
              event_label: categoryID
            });
          }
        }
      });
    }
  }

  /**
     * @function sizeGuideClick - Get seo event when click on product size guide
     * @param {Array} elements - array with all necessary elements
     */
  sizeGuideClick(elements) {
    if (this.checkIfArray(elements, 3)) {
      $(document).on('click', elements[0], (e) => {
        let pid = $(elements[1]).data(elements[2]);
        if (pid) {
          dataLayer.push({
            event: 'asyncAction',
            gaHitType: 'event',
            event_category: 'pdp',
            event_action: 'guida_alle_taglie',
            event_label: pid
          });
        }
      });
    }
  }

  /**
     * @function selectedVariant - Get seo event when select a variant product
     * @param {Array} elements - array with all necessary elements
     */
  selectedVariant($self, elements) {
    if (this.checkIfArray(elements, 3)) {
      let $productContainer = $self.closest(elements[0]);
      let pid = $productContainer.data(elements[1]);
      let colorName = $self.attr(elements[2]);
      if (pid && colorName) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'pdp',
          event_action: 'selezione_variante',
          event_label: pid + '|' + colorName
        });
      }
    }
  }

  /**
     * @function clickQuickviewProduct - Get seo event when open quickview product
     * @param {Array} elements - array with all necessary elements
     */
  clickQuickViewProduct(elements) {
    if (this.checkIfArray(elements, 5)) {
      var pid = $(elements[0]).find(elements[1]).data(elements[2]);
      var colorName = $($(elements[3])[0]).attr(elements[4]);
      if (pid && colorName) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'listing',
          event_action: 'popup_prodotto',
          event_label: pid + '|' + colorName
        });
      }
    }
  }

  /**
     * @function productColorClick - Get seo event when click on product color in PLP
     * @param {Array} elements - array with all necessary elements
     */
  productColorClick(elements) {
    if (this.checkIfArray(elements, 5)) {
      const isColor = $(elements[0]);
      if (isColor.length) {
        isColor.on('click', elements[1], (event) => {
          const $self = $(event.currentTarget);
          let pid = $self.closest(elements[2]).data(elements[3]);
          let colorName = $self.attr(elements[4]);
          if (pid && colorName) {
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'listing',
              event_action: 'selezione_variante',
              event_label: pid + '|' + colorName
            });
          }
        });
      }
    }
  }

  /**
     * @function showMoreClick - Get seo event when click on show more button in PLP
     */
  showMoreClick() {
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      event_category: 'listing',
      event_action: 'carica_altri_prodotti'
    });
  }

  /**
     * @function layout1ViewPlp - Get seo event when click on layout1 view plp
     */
  layoutSmallViewPlp() {
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      event_category: 'listing',
      event_action: 'tipo_visualizzazione',
      event_label: 'small' // click sul pulsante a sinistra
    });
  }

  /**
     * @function layout2ViewPlp - Get seo event when click on layout2 view plp
     */
  layoutBigViewPlp() {
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      event_category: 'listing',
      event_action: 'tipo_visualizzazione',
      event_label: 'big' // click sul pulsante a destra
    });
  }

  /**
     * @function paginationEventClick - Get seo event when click on pagination
     * @param $selfButton - Pagination button
     * @param {Array} elements - array with all necessary elements
     */
  paginationEventClick($selfButton, elements) {
    if (this.checkIfArray(elements, 4)) {
      if ($(elements[0]).hasClass(elements[1])) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'listing',
          event_action: 'paginazione',
          event_label: 'next_page'
        });
      } else if ($(elements[0]).hasClass(elements[2])) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'listing',
          event_action: 'paginazione',
          event_label: 'prev_page'
        });
      } else {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'listing',
          event_action: 'paginazione',
          event_label: $selfButton.attr(elements[3])
        });
      }
    }
  }

  /**
     * @function registerOkEvent - Get seo event when click on register account and return ok
     * @param profiling - Profilazione user
     * @param newsletter - Newsletter user
     */
  registerOkEvent(profiling, newsletter) {
    let event_label = [];
    if (newsletter) {
      event_label.push('newsletter');
    }
    if (profiling) {
      event_label.push('profilazione');
    }
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      event_category: 'registrazione',
      event_action: 'registrazione_ok',
      event_label: event_label.join('|')
    });
  }

  /**
     * @function clickOnChangeEmail - Get seo event when click on change email in edit profile myaccount
     * @param {Array} elements - array with all necessary elements
     */
  clickOnChangeEmail(elements) {
    if (this.checkIfArray(elements, 2)) {
      $(elements[0]).on('click', elements[1], (e) => {
        // click su Cambia Indirizzo Email
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'my_account',
          event_action: 'cambia_indirizzo_email',
          event_label: ''
        });
      });
    }
  }

  /**
     * @function clickOnChangeEmail - Get seo event when click on change password in edit profile myaccount
     * @param {Array} elements - array with all necessary elements
     */
  clickOnChangePassword(elements) {
    if (this.checkIfArray(elements, 2)) {
      $(elements[0]).on('click', elements[1], (e) => {
        // click su Cambia Password
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'my_account',
          event_action: 'cambia_password',
          event_label: ''
        });
      });
    }
  }

  /**
     * @function checkoutFormError - Get seo event when click on submit form checkout
     * @param {String} checkoutStep - checkout step number
     * @param {Object} element - jquery object representing the element with error
     */
  checkoutFormError(checkoutStep, elements) {
    if (this.checkIfArray(elements, 1) && checkoutStep) {
      let checkoutStages = {
        shipping: '1',
        payment: '2',
        placeorder: '3'
      };
      let eventAction = [];
      let eventLabel = [];

      elements.forEach((element) => {
        if (!$(element).is('input') && !$(element).is('select')) {
          element = $(element).find('input, select').get(0);
        }

        if (eventAction.indexOf(element.id) <= -1) {
          eventAction.push(element.id);
        }

        if (typeof element.dataset !== 'undefined' && typeof element.dataset.parsleyRequiredMessage !== 'undefined') {
          eventLabel.push(element.dataset.parsleyRequiredMessage);
        } else if ($(element).siblings('.errors-list').length > 0) {
          eventLabel.push($(element).siblings('.errors-list').first().text());
        } else {
          eventLabel.push('');
        }
      });
      if (eventAction.length && eventLabel.length) {
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'errori_checkout_' + checkoutStages[checkoutStep],
          event_action: eventAction.join('|'),
          event_label: eventLabel.join('|')
        });
      }
    }
  }

  checkIfArray(elements, mandatoryLength) {
    if (elements instanceof Array && elements.length >= mandatoryLength) {
      return true;
    }
    return false;
  }

  init() {
    // placeholder
  }

  /* // rimosso con il tracciamento ibrido con GA4
  productSeoValorize() {
    $(document).on('click', '.product-tile a', function (e) {
      Seo.productImpressions();
      if ($(this).hasClass('quickview')) {
        return true;
      }
      var listArray = [];
      var prodLayerArray = [];
      var listObj = Seo.generateProductTrackingModel($(e.target).closest('.product-tile'));
      listArray.push(listObj);
      var productObj = Seo.generateProductTrackingModel($(e.target).closest('.product-tile'));
      prodLayerArray.push(productObj);
      if (prodLayerArray[0].list) {
        delete prodLayerArray[0].list;
      }

      if (typeof dataLayer !== 'undefined') {
        let event = {
          event: 'productClick',
          ecommerce: {
            click: {
              actionField: {
                list: (listArray[0] && listArray[0].list) ? listArray[0].list : ''
              },
              products: prodLayerArray
            }
          }
        };
        dataLayer.push(event);
      }
    });
  } */

  pushATC(analyticsP, dataLayerGA4){
    let listName = this.pushListType();
    let modalOpen = $('.quick-view-modal').attr('aria-hidden'); //if open aria-hidden == false
    let section = pageTypeForJS;
    if(modalOpen === 'false'){
      section = 'quick_view'
    }
    if (analyticsP) {
      analyticsP = JSON.parse(decodeURIComponent(analyticsP));
      let selectedSizeElem = $('.list-size li.selected span')[0];
      let selectedSize = selectedSizeElem?selectedSizeElem.innerHTML:null;
      let selectedFamilyColorElem = $('a.swatch-color.selected');
      let selectedFamilyColor = selectedFamilyColorElem?selectedFamilyColorElem.data('familyColorSearch'):null;
      if(selectedSize){
        let analyticsObj = {
          where: section,
          event: 'add_to_cart'
        };

        if(typeof dataLayerGA4 !== "undefined" && dataLayerGA4 !== null) analyticsObj.ecommerce = dataLayerGA4;
        dataLayer.push(analyticsObj);
      }
    }
  }

  pushListType() {
    let list;
    let modalOpen = $('.quick-view-modal').attr('aria-hidden'); //if open aria-hidden == false
    if (modalOpen === 'false') {
      switch (pageTypeForJS) {
        case 'plp':
          list = 'category_listing';
          break;
        case 'pdp':
          list = 'related_product';
          break;
        case 'cart':
          list = 'related_products_cart';
          break;
        default:
          list = 'null';
          break;
      }
    }
    return list;
  }

  generateProductTrackingModelWishlist(element){
    return Seo.generateProductTrackingModelWishlist(element);
  }
}

const EnhancedSeo = new enhancedSeo();
export default EnhancedSeo;



// WEBPACK FOOTER //
// ./assets/scripts/enhancedSeo.js